import { render, staticRenderFns } from "./H5ActivityPushList.vue?vue&type=template&id=5bc432c3&scoped=true"
import script from "./H5ActivityPushList.vue?vue&type=script&lang=js"
export * from "./H5ActivityPushList.vue?vue&type=script&lang=js"
import style0 from "./H5ActivityPushList.vue?vue&type=style&index=0&id=5bc432c3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc432c3",
  null
  
)

export default component.exports